import { render, staticRenderFns } from "./AddPostService.vue?vue&type=template&id=51cce024&"
import script from "./AddPostService.vue?vue&type=script&lang=js&"
export * from "./AddPostService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports